import React from "react";
import Banner from "../component/Banner";
import Header from "../component/header";
import Misson from "../component/Ourmission";
import ShineRefineUplift from "../component/ShineRefineUplift";
import Spotlight from "../component/Spotlight";
import Offer from "../component/Offer";
import Support from "../component/SupportArtist";
import Footer from "../component/Footer";
import MemberPathways from "../component/MemberPathways";
import BannerImg from "../image/about.png";
function AboutUs() {
  return (
    <>
      <Header />
      <Banner
        backgroundImage={BannerImg}
        heading="Lightweave Beacon Legacy"
        paragraph="Lightweave Beacon Legacy (LWBL) is a digital gallery, learning hub, and creative community dedicated to empowering visual artists across the world. We provide a space where emerging and professional artists can showcase their work, improve their skills, participate in challenges, and gain recognition from peers, mentors, and patrons."
        minHeight="100vh"
        padding="80px 0"
        bton="Members please sign-in"
      />
      <Misson />
      <ShineRefineUplift />
      <MemberPathways />
      <Offer />
      <Support />
      <Spotlight />
      <Footer />
    </>
  );
}

export default AboutUs;
